import { FaInstagram, FaLinkedin, FaYoutube, FaFacebookF } from "react-icons/fa";
import useGetCompanyInfo from '../Hooks/useGetCompanyInfo';
import { useNavigate } from 'react-router-dom';
import packageJson from '../../package.json'

import './Footer.css'
import { useAuth } from "../Providers/AuthProvider";
import { useParams } from "../Providers/ParamsProvider";

const Footer = () => {
    const { footerData, companyInfoData } = useGetCompanyInfo()
    const navigate = useNavigate();
    const { isMobile } = useParams();

    const handleReDirect = (link, direct) => {
        if (direct) {
            navigate(link)
        }
        else {
            window.open(link, '_blank')
        }
    }

    const safeStr = companyInfoData.logoSourceWhiteMode || ''; // default to empty string
    const logoPath = companyInfoData ? safeStr.replace('../', '') : '';

    return (
        companyInfoData && footerData.footerHeader &&
        <div className="container-fluid container-fluid-with-paddings  mt-5 mb-5">
            <div className="row mb-5">
                <h1>
                    {/* <img src={companyInfoData.logoSourceWhiteMode} style={{ width: 100 }} /> */}
                    <img src={`${process.env.PUBLIC_URL}/${logoPath}`} style={{ width: 100 }} />
                </h1>
            </div>
            <div className="row">
                <div className="col-12 col-md-3">
                    <div className='footer-contact-item'>{companyInfoData.name}</div>
                    <div className='footer-contact-item'>{companyInfoData.zip} {companyInfoData.city}</div>
                    <div className='footer-contact-item'>{companyInfoData.street}</div>
                    <div className='footer-contact-item mt-4'>{`tel: ${companyInfoData.phone}`}</div>
                    <div className='footer-contact-item'>{companyInfoData.email}</div>
                    <div className='d-flex mt-5 mb-5'>
                        <FaFacebookF className='me-3 element-pointer' size={35} onClick={() => handleReDirect(companyInfoData.facebook, false)} />
                        <FaInstagram className='me-3 element-pointer' size={35} onClick={() => handleReDirect(companyInfoData.instagram, false)} />
                        <FaYoutube className='me-3 element-pointer' size={35} onClick={() => handleReDirect(companyInfoData.youtube, false)} />
                        <FaLinkedin className="element-pointer" size={35} onClick={() => handleReDirect(companyInfoData.linkedIn, false)} />
                    </div>
                </div>
                <div className="col">
                    <div className='row display-flex justify-content-center'>
                        {footerData.footerHeader.length > 0 && footerData.footerHeader.map((header, index) => {
                            return <div className='col-sm-12 col-md-6 col-lg-3 mb-5' key={index}>
                                <h3 style={{ marginBottom: "20px", fontSize: 18, fontWeight: "bold" }}>
                                    {header.title}
                                </h3>
                                {header.footerItems.map((item, index) => {
                                    if (item.headerId == header.headerId) {
                                        return <Item
                                            index={index}
                                            item={item}
                                            handleReDirect={handleReDirect}
                                        />
                                    }
                                })}
                            </div>
                        })}
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-6">
                    <span>Wszystkie prawa zastrzeżone 2024 {companyInfoData.name}</span>
                </div>
                <div className="col-6 text-end">
                    <span>{`eHandel ${packageJson.versionsReleaseDateHistory[0]}`}</span>
                </div>
            </div>
        </div>
    )
}

const Item = ({ index, item, handleReDirect }) => {
    const { authState } = useAuth()
    if (authState.user && (item.title.toLowerCase().includes('zaloguj') || item.title.toLowerCase().includes('zarejestruj'))) {
        return null
    }
    return <div className='row' key={index}>
        <span className='element-pointer' onClick={() => handleReDirect(item.url, item.isDirect)}>{item.title}</span>
    </div>
}

export default Footer